import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ButtonBase,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';

import {
  getStripeV2State,
  subscribeCourse,
} from '../../../../store/V2/StripeSlice';
import { getAuthState } from '../../../../store/AuthSlice';
import { ICourseForUser } from '../../../../store/V2/CoursesSlice';
import { TP_COLORS } from '../../../../constants';
import { useAppSelector } from '../../../../hooks';
import { getSubjectColorNew } from '../../../../helper';
import SubscriptionLoginPopupModal from '../modals/SubscriptionLoginPopupModal';

interface SubscriptionCardProps {
  course: ICourseForUser;
}

const subscriptButtonStyles: SxProps = {
  width: '100%',
  padding: '15px',
  color: TP_COLORS.white,
  borderRadius: '5px',
  fontSize: '14px',
  fontWeight: 600,
};

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({ course }) => {
  const dispatch = useDispatch();

  // Store
  const stripeV2State = useAppSelector(getStripeV2State);
  const authState = useAppSelector(getAuthState);

  // State
  const [isModalOpen, setModalOpen] = useState(false);

  const authUser = authState.user;
  const subjectColor = course.subject
    ? getSubjectColorNew(course.subject)
    : '#1C9FF7';

  const isGuest =
    !authUser || (authUser && authUser.role && authUser.role.isGuest);

  const amount = course.amount
    ? parseFloat(course.amount.toFixed(2)).toString()
    : '';

  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };

  const handleSubscribe = () => {
    if (isGuest) {
      toggleModal();
    } else {
      dispatch(
        subscribeCourse({
          courseId: course._id,
        })
      );
    }
  };

  const CustomListItem = ({ text }: { text: string }) => {
    return (
      <Typography
        component="li"
        color="#003768"
        fontSize="13px"
        fontWeight={600}
        sx={{ mb: '10px', '&::marker': { color: subjectColor } }}
      >
        {text}
      </Typography>
    );
  };

  return (
    <Card
      elevation={0}
      style={{
        backgroundColor: '#F1F5F9',
        borderRadius: '20px',
        maxWidth: '310px',
      }}
    >
      <CardContent style={{ padding: '32px 16px 16px 16px' }}>
        <div style={{ marginBottom: '10px' }}>
          <Typography
            fontSize="16px"
            fontWeight={500}
            color="#1E293B"
            textAlign="center"
          >
            {course.title}
          </Typography>
        </div>
        <div>
          <Typography
            fontSize="44px"
            fontWeight={900}
            textAlign="center"
            color={subjectColor}
          >
            {course.currency} {amount}
          </Typography>
        </div>
        {/* <div style={{ marginTop: '-10px', marginBottom: '15px' }}>
          <Typography
            fontSize="16px"
            fontWeight={400}
            textAlign="center"
            color="#647488"
          >
            Was <del>14.00</del>
          </Typography>
        </div> */}
        <Stack alignItems="center" style={{ marginBottom: '15px' }}>
          <ButtonBase
            disabled={stripeV2State.status === 'loading'}
            sx={{ ...subscriptButtonStyles, backgroundColor: subjectColor }}
            onClick={handleSubscribe}
          >
            {stripeV2State.status === 'loading' ? (
              <>
                <CircularProgress size={15} sx={{ color: '#ffffff' }} />
                &nbsp;
              </>
            ) : (
              'SUBSCRIBE'
            )}
          </ButtonBase>
        </Stack>
        <div style={{ marginBottom: '30px' }}>
          <Typography component="ul">
            {(course.pricingDetails || []).map((item, index) => (
              <CustomListItem key={`li-${index}`} text={item} />
            ))}
          </Typography>
        </div>
        {/* <Card
          sx={{
            background: `url('${process.env.PUBLIC_URL}/images/shapes/idk-teacher.png') bottom right/contain no-repeat, linear-gradient(103.87deg, #006C9C 7.37%, #002536 100%)`,
          }}
        >
          <CardContent style={{ paddingBottom: '16px' }}>
            <div style={{ marginBottom: '20px' }}>
              <Typography
                fontSize="20px"
                fontWeight={700}
                color={TP_COLORS.white}
              >
                Still Deciding?
              </Typography>
            </div>
            <div>
              <Button size="small" variant="contained" color="inherit">
                Book A Trial Class
              </Button>
            </div>
          </CardContent>
        </Card> */}
      </CardContent>
      {/* Modals */}
      <SubscriptionLoginPopupModal open={isModalOpen} onClose={toggleModal} />
    </Card>
  );
};

export default SubscriptionCard;
